import { createSelector } from 'reselect';

export const getEditorialState = (state) => state.editorial;

export const isLoadingEditorial = (state) => getEditorialState(state).isLoading;

export const getEditorialData = (state) => getEditorialState(state).data;

// export const getPageSeoMetadataWithStatus = createSelector(
//     getPageSEOMetadata,
//     getLoadPageSEOMetadataStatus,
//     (data = {}, status = {}) => ({ ...data, ...status }),
// );